module.exports = __webpack_public_path__ + "img/map_corner-mezzanine.02c42551.jpg";